import { Component, Input } from '@angular/core';
import { IClock } from '../../../../interfaces/production-thirty-minutes';

@Component({
  selector: 'app-clock',
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.scss']
})
export class ClockComponent {

  @Input() public clockData: IClock;

  constructor() { }
}
